import styled from 'styled-components'

export const About = styled.div`
  padding: 40px 0 0px;
  overflow: hidden;
  max-width: 100%;
  position: relative;
  background: #fff;

  .title {
    font-size: 36px;
    font-weight: 900;
    color: #000;
    text-align: left;
    margin-bottom: 40px;
  }

  .grid {
    display: flex;

    > div {
      flex: 1;
      min-height: 384px;
    }

    .image-feature {
      width: 640px;
      height: 484px;
      position: absolute;
      margin-left: 60px;
      margin-top: -100px;
    }

    .main-content {
      p {
        margin-bottom: 20px;
      }
    }
  }

  .staff {
    display: flex;
    margin-top: 70px;

    .person {
      flex: 1;
      display: flex;

      &__picture {
        width: 108px;
        margin-right: 20px;

        img {
          border-bottom: 4px solid var(--color-secondary);
        }
      }

      &__info {
        flex: 1;
        padding-right: 50px;

        &-name {
          font-size: 22px;
          font-weight: 700;
        }

        &-position {
          font-size: 20px;
          margin-bottom: 20px;
        }

        &-bio {
          max-height: 90px;
          overflow: hidden;
          position: relative;
          transition: all 0.3s;

          &--show {
            max-height: 1000px !important;
            transition: all 0.6s;

            &:after {
              height: 0 !important;
              transition: all 0.6s;
            }
          }

          &:after {
            content: '';
            position: absolute;
            width: 100%;
            height: 50px;
            left: 0;
            bottom: 0;
            transition: all 0.3s;
            background: rgba(255,255,255,0);
            background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
            background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,255,255,0)), color-stop(100%, rgba(255,255,255,1)));
            background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
            background: -o-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
            background: -ms-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
            background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff', GradientType=0 );
          }
        }

        &-readmore {
          color: var(--color-primary);
          font-weight: 700;
          background: transparent;
          border: 0;
          padding: 20px;
          cursor: pointer;
          font-size: 18px;
          margin-left: -20px;
          margin-top: 10px;
          outline: none;

          &--hide {
            color: #9e9e9e;

            &::before {
              content: '-' !important;
            }
          }

          &::before {
            content: '+';
            font-weight: 900;
            margin-right: 10px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .staff {
      flex-direction: column;

      .person {
        margin-bottom: 30px;

        &__picture {
          width: 60px;

          > div {
            width: 60px !important;
            height: 60px !important;
          }
        }
      }
    }

    .grid {
      flex-direction: column;

      .main-content {
        margin-bottom: 40px;
      }

      > div {
        min-height: auto;
      }

      .image-feature {
        position: relative;
        margin-left: -80px;
        margin-top: 0px;
      }
    }
  }
`